module.exports = __webpack_public_path__ + "img/221.224e6d30.png";